"use strict";
/*
 * Created on 1. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Type of selected final price.
 * @author Radek Beran
 */

var FinalPriceType;

(function (FinalPriceType) {
  FinalPriceType["OptimalWithConstraints"] = "OptimalWithConstraints";
  FinalPriceType["OptimalWithoutConstraints"] = "OptimalWithoutConstraints";
  FinalPriceType["Regular"] = "Regular";
  FinalPriceType["Manual"] = "Manual";
  FinalPriceType["Sellout"] = "Sellout";
  /**
   * This marks manual price, which is no longer actual - used when reopening release to force recalculation
   * without unpleasant hacking.
   */

  FinalPriceType["ManualOld"] = "ManualOld";
})(FinalPriceType = exports.FinalPriceType || (exports.FinalPriceType = {}));